import api from '../token';

export const AddArmazem = async (dados) => {
  try {
    const response = await api.post('/addArmazem', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};


